import React, { useState } from "react";
import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getPerm } from "../../../utils/perm";
import {
  changePasswordThunk,
  clearChangePasswordMsg,
} from "../../../store/slices/changePasswordSlice";

export default function ChangePasswordPage() {
  const dispatch = useDispatch();
  const { saving, error, success } = useSelector((s) => s.changePassword);

  const permsMap = useSelector((s) => s.permissions?.map) || {};
  const perms = getPerm(permsMap, "change_password") || {};
  const canUpdate = !!perms.can_update;

  const [form, setForm] = useState({
    old_password: "",
    new_password: "",
    confirm_password: "",
  });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!canUpdate) return;

    if (!form.old_password || !form.new_password) return;
    if (form.new_password !== form.confirm_password) return;

    await dispatch(changePasswordThunk(form));
  };

  return (
    <div className="container-fluid">
      <Row className="mb-3">
        <Col>
          <h4 style={{ fontWeight: 600, marginBottom: 4 }}>Change Password</h4>
          <div style={{ color: "#6b7280", fontSize: 13 }}>
            Update your login password
          </div>
        </Col>
      </Row>

      {error ? (
        <Alert variant="danger" onClose={() => dispatch(clearChangePasswordMsg())} dismissible>
          {error}
        </Alert>
      ) : null}

      {success ? (
        <Alert variant="success" onClose={() => dispatch(clearChangePasswordMsg())} dismissible>
          {success}
        </Alert>
      ) : null}

      <Card style={{ borderRadius: 14, maxWidth: 650 }}>
        <Card.Body>
          <Form onSubmit={onSubmit}>
            <Row className="g-3">
              <Col md={12}>
                <Form.Group>
                  <Form.Label style={{ fontWeight: 500 }}>Old Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={form.old_password}
                    onChange={(e) => setForm((p) => ({ ...p, old_password: e.target.value }))}
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group>
                  <Form.Label style={{ fontWeight: 500 }}>New Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={form.new_password}
                    onChange={(e) => setForm((p) => ({ ...p, new_password: e.target.value }))}
                  />
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group>
                  <Form.Label style={{ fontWeight: 500 }}>Confirm Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={form.confirm_password}
                    onChange={(e) => setForm((p) => ({ ...p, confirm_password: e.target.value }))}
                  />
                  {form.new_password &&
                  form.confirm_password &&
                  form.new_password !== form.confirm_password ? (
                    <div style={{ color: "#ef4444", fontWeight: 600, marginTop: 6 }}>
                      Password not matching
                    </div>
                  ) : null}
                </Form.Group>
              </Col>
            </Row>

            <div className="mt-4">
              <Button
                type="submit"
                disabled={
                  !canUpdate ||
                  saving ||
                  !form.old_password ||
                  !form.new_password ||
                  form.new_password !== form.confirm_password
                }
              >
                {saving ? (
                  <>
                    <Spinner size="sm" animation="border" /> Saving...
                  </>
                ) : (
                  "Update Password"
                )}
              </Button>

              {!canUpdate ? (
                <span style={{ marginLeft: 10, color: "#ef4444", fontWeight: 700 }}>
                  No Update permission
                </span>
              ) : null}
            </div>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
